import { getCoreRowModel, useReactTable } from '@tanstack/react-table'

import {
  UsePaginatedReactTable,
  UsePaginatedReactTableParams,
} from './use-paginated-table'

const usePaginatedTable = <T>({
  paginatedQuery,
  columns,
  defaultColumn,
  paginatedTableOptions,
}: UsePaginatedReactTableParams<T>): UsePaginatedReactTable<T> => {
  const tableInstance = useReactTable<T>({
    data: paginatedQuery.data?.data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: defaultColumn ?? {
      minSize: 150,
    },
    ...paginatedTableOptions,
  })

  return { tableInstance }
}

export default usePaginatedTable
